import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';

import { definitionLabel } from 'styles/base-classes';

const Label = styled('span')<any>`
  ${definitionLabel};
  margin-bottom: 0.1em;
  display: ${({ display }): string => (display ? display : 'block')};
  ${({ newDesign }): string | null =>
    newDesign &&
    `
    font-size: 16px;
    letter-spacing: normal;
  `}
  @media screen and (max-width: 1024px) {
    margin-right: 5px;
  }
`;

interface IWithLabelProps {
  children: ReactNode;
  shouldDisplayLabel: boolean;
  label: string;
  newDesign?: boolean;
  display?: string;
  id?: string;
}

const WithLabel: React.FC<IWithLabelProps> = (props) => {
  const { children, shouldDisplayLabel, label, newDesign, display, id } = props;
  if (shouldDisplayLabel) {
    return (
      <div>
        <Label id={id} display={display} newDesign={newDesign}>
          {label}
        </Label>
        {children}
      </div>
    );
  }

  // The frag around children is just there to shut up a strange TS compile error
  return <>{children}</>;
};

export default WithLabel;
